<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-7.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Qualifications</span>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="random-actions"></div>
<app-table
  hasActions="true"
  [settings]="settings"
  [rows]="qualifications"
  [columns]="headings"
  (deleted)="confirmDelete($event)"
  [tableCellTemplate]="cellTemplate"
>
  <ng-template #cellTemplate let-cell="cell">
    <div class="cell">
      <span>{{ cell.value }}</span>
    </div>
  </ng-template>
</app-table>
